import $ from 'jquery';
import {onScroll, getScrollTop, getWidth, getHeight} from '../utils/window';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const body = $('body');
	const $header = $('#header');
	const $headerBg = $('#header > .background');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	let pStart = {x: 0, y:0};
	let pStop = {x:0, y:0};
	let wasPulledDown = false;

	$(function(){
		let top = 0;

		if (headerToggler) {

			headerToggler.on('toggle', function() {
				$html.toggleClass('is-header-open', headerToggler.isOpen);

				if (headerToggler.isOpen) {
					// $scroller.animate({ scrollTop: 0 }, { duration: 200 });
					top = getScrollTop();
					let subOpen = document.querySelectorAll('[data-submenu="opened"]');
					if(subOpen) {
						subOpen.forEach((submenu) => {
							submenu.dataset.submenu = 'closed';
						});
					}
					$('#menu.menu').removeClass('is-closed').addClass('is-open');
					setTimeout(function(){
						$('#menu.menu').addClass('is-opening');
					}, 100);

					setTimeout(()=> {
						setupNoScroll();
					}, 300);
				} else {
					removeNoScroll(top);

					$('#menu.menu').addClass('is-closing');

					setTimeout(()=>{
						$('#menu.menu').removeClass('is-open').removeClass('is-opening').removeClass('is-closing').addClass('is-closed');
					}, 350);
				}
			});
		}

		let lastScrollTop = 0;

		onScroll(function(event){
			let st = getScrollTop();
			let headerHeight = $header.outerHeight();
			if (st > lastScrollTop){
				// downscroll code
				if(st > headerHeight) {
					$header.addClass('is-scrolled');
					$header.removeClass('is-stuck');
				} else {
					$header.removeClass('is-scrolled');
					$header.addClass('is-stuck');
				}
				$headerNav.css({ transform: 'translateY(-' + st + 'px)' });
			} else {
				// upscroll code
				if(st == 0 || st < 0) {
					$header.removeClass('is-scrolled');
					$header.removeClass('is-stuck');
					$headerNav.css({ transform: '' });
				} else {
					$header.removeClass('is-scrolled');
					$header.addClass('is-stuck');
					$headerNav.css({ transform: 'translateY(-' + (st) + 'px)' });
				}
			}
			lastScrollTop = st;
		});
	});

	$(window).on('load', function(){
		//if tablet or mobile
		if(getWidth() < 1080) {
			document.addEventListener('touchstart', function(e){ swipeStart(e); }, false);
			document.addEventListener('touchend', function(e){ swipeEnd(e); }, false);
		}

		$('.text > p, .text > h3,  .text > h4, .text > h5, .text > h6').each(function() {
			$(this).html($(this).html().replace(/\s([^\s<]+)\s*$/,'&nbsp;$1'));
		});
	});

	function addBgColour() {
		let isBlack = $header.hasClass('-overlay');
		let colour = false;
		let headerBgColour = $headerBg.css('background-color');

		if(isBlack) {
			colour = '#000000';
		}

		if(headerBgColour !== '' && headerBgColour !== null && headerBgColour !== 'rgba(0, 0, 0, 0)') {
			colour = $headerBg.css('background-color');
		}

		if(colour) {
			body.css('background-color', colour);
		}
	}

	function removeBgColour(timer=false) {
		if(timer) {
			setTimeout(()=>{
				body.css('background-color', '');
			}, 1000);
		} else {
			body.css('background-color', '');
		}
	}

	function swipeStart(e) {
		if (typeof e['targetTouches'] !== "undefined"){
			var touch = e.targetTouches[0];
			pStart.x = touch.screenX;
			pStart.y = touch.screenY;
		} else {
			pStart.x = e.screenX;
			pStart.y = e.screenY;
		}

		if(getScrollTop() < getHeight() - 100 ) {
			addBgColour();
			wasPulledDown = true;
		}
	}

	function swipeEnd(e){
		if (typeof e['changedTouches'] !== "undefined"){
			var touch = e.changedTouches[0];
			pStop.x = touch.screenX;
			pStop.y = touch.screenY;
		} else {
			pStop.x = e.screenX;
			pStop.y = e.screenY;
		}

		swipeCheck();
	}

	function swipeCheck(){
		var changeY = pStart.y - pStop.y;
		var changeX = pStart.x - pStop.x;
		if (isPullDown(changeY, changeX) ) {
			// alert('Swipe Down!');
			addBgColour();
			wasPulledDown = true;
		} else {
			removeBgColour();
		}
	}

	function isPullDown(dY, dX) {
		// methods of checking slope, length, direction of line created by swipe action
		return dY < 0 && (
			(Math.abs(dX) <= 100 && Math.abs(dY) >= 300)
			|| (Math.abs(dX)/Math.abs(dY) <= 0.3 && dY >= 60)
		);
	}

	function setupNoScroll() {
		const body = $('body');

		body.css('position', 'fixed');
		body.css('width', '100%');
		body.css('height', getHeight());
		body.css('overflow', 'hidden');
	}

	function removeNoScroll(st) {
		const body = $('body');

		body.css('position', '');
		body.css('width', '');
		body.css('height', '');
		body.css('overflow', '');

		$html.scrollTop(st);
	}

	function subMenuClick(submenu) {
		let data = submenu.dataset.submenu;
			if(data == 'closed') {
				submenu.dataset.submenu = 'opened';
			
				/* closes off others in the same level if opened */
				let parent = submenu.parentNode;
				let children = parent.childNodes;
				children.forEach((child) => {
					if(child.nodeType === 1) {
						if(child !== submenu) {
							if(child.dataset.submenu) {
							child.dataset.submenu = 'closed';
							}
						}
					}
				});

			} else {
				submenu.dataset.submenu = 'closed';
			}			
	}

	const submenus = document.querySelectorAll('[data-submenu]');
	submenus.forEach((submenu) => {

		submenu.addEventListener('click', (e) => {
			if(e.target == submenu) {
				e.stopPropagation();
				subMenuClick(submenu);
			}
		});

		submenu.addEventListener('keydown', (e) => {
			if(e.keyCode === 13) {
				e.stopPropagation();
				subMenuClick(submenu);
			}
		});

	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js